import "select2";
import "select2/dist/css/select2.css";

jQuery(document).ready(function ($) {
  const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-right-square" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707z"/>
                    </svg>`;

  function formatOption(option) {
    if (!option.id) {
      return option.text;
    }

    const $el = $(option.element);
    const url = $el.data("url");

    const $container = $('<span class="term-option"></span>').text(option.text);

    if (url) {
      const $link = $("<a>")
        .attr("href", url)
        .attr("target", "_blank")
        .addClass("term-option-link")
        .html(arrowSvg);

      $container.append($link);
    }

    return $container;
  }

  const searchForm = document.querySelector(
    "form.wp-block-pivot-288-search-form"
  );
  const searchFormInput = searchForm.querySelector('input[name="s"]');
  const searchFormClearFilters = searchForm.querySelector(
    ".search-filters-clear"
  );

  const searchFormSelectFields = [
    {
      element: searchForm.querySelector('select[name="categories[]"]'),
      placeholder: "Filtrer la catégorie",
    },
    {
      element: searchForm.querySelector('select[name="themes[]"]'),
      placeholder: "Filtrer le thème",
    },
    {
      element: searchForm.querySelector('select[name="author__in[]"]'),
      placeholder: "Filtrer l'auteur·e",
    },
  ];

  searchFormClearFilters.addEventListener("click", function (event) {
    searchFormSelectFields.forEach(({ element }) => {
      $(element).val(null).trigger("change");
    });
  });

  searchFormSelectFields.forEach(({ element, placeholder }) => {
    $(element).select2({
      placeholder: placeholder,
      allowClear: true,
      dropdownParent: $(searchForm.querySelector(".search-filters")),
      dropdownCssClass: "select2-pivot-288-search-dropdown",
      language: {
        noResults: function () {
          return "Aucun résultat trouvé";
        },
      },
      templateResult: formatOption,
      selectionCssClass: "select2-pivot-288-search-selection",
      width: "",
    });

    $(element).on("select2:open", function () {
      const $results = $(".select2-results");

      $results.off("mousedown.termLink");
      $results.off("click.termLink");

      $results.on("mousedown.termLink", ".term-option-link", function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = this.href;
      });

      $results.on("click.termLink", ".term-option-link", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  });
});
